var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafe = function SvgSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17A5 5 0 109 7a5 5 0 000 10zm2.445-3.262c.258-.361.437-.782.514-1.238H11.5a.5.5 0 010-1h.459a2.985 2.985 0 00-.514-1.238l-.299.299a.5.5 0 01-.707-.707l.3-.3A2.984 2.984 0 009.5 9.042V9.5a.5.5 0 11-1 0v-.459a2.984 2.984 0 00-1.237.513l.3.3a.5.5 0 11-.708.707l-.3-.3a2.984 2.984 0 00-.514 1.239h.46a.5.5 0 010 1h-.46c.077.456.257.878.514 1.24l.3-.3a.5.5 0 01.708.707l-.3.3c.361.256.782.435 1.237.512V14.5a.5.5 0 011 0v.459a2.983 2.983 0 001.238-.514l-.299-.299a.5.5 0 01.707-.707l.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14v-1.268A2 2 0 0018 9a2 2 0 00-1 3.732V14a1 1 0 102 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2a1 1 0 00-1 1v18a1 1 0 001 1h2a1 1 0 001 1h4a1 1 0 001-1h6a1 1 0 001 1h4a1 1 0 001-1h2a1 1 0 001-1V3a1 1 0 00-1-1H1zm1 2v16h20V4H2z"
  }))));
};
export default SvgSafe;